export default {
  mediaChannel: 'Media Channel',
  allChannels: 'All Channels',
  addNewRestriction: 'Add New Restriction',
  newRestrictionTitle: 'New Restriction',
  restrictionType: 'Restriction Type',
  exactly: 'Equal',
  lessThan: 'Less than or equal',
  moreThan: 'Greater than or equal',
  between: 'Between',
  value: 'Value',
  minValue: 'Min',
  maxValue: 'Max',
  restrictionTimespan: 'Restriction Period',
  fullPeriod: 'Full Period',
  customRange: 'Custom Range',
  fromDate: 'From',
  toDate: 'To',
  addRestriction: 'Add Restriction',
  editRestrictionTitle: 'Edit Restriction',
  saveRestriction: 'Save',
  edit: 'Edit',
  delete: 'Delete',
  cancel: 'Cancel',
  duplicateError: 'An identical restriction for these channels and this period already exists',
  combinedRestriction: 'Combined restriction across: {channels}',
  valueMustBeNonNegative: 'Value cannot be negative',
  maxMustBeGreaterThanMin: 'Max must be greater than min',
  mediaChannelRequired: 'Please select at least one media channel',
  selectDateRange: 'Please select a date range',
  fromDateMustBeBeforeToDate: 'Start date must be before end date'
}
